const dsBridge = require('dsbridge')

// 0：返回 1：首页 2：选择图片 3：银行卡页面 4:进入h5页面关闭loading
export default {
  install (Vue, options) {
    Vue.prototype.$javaNative = function (behavior, result) {
      dsBridge.call('android.handle', JSON.stringify([behavior]),
        function (res) {
          result(JSON.parse(res))
        })
    }
  }
}
